import './docs.scss';
import { initNavbar, initFooterYear } from '@/ui';
import { initLocalMode } from '@/services/localMode';
import { initPostHog } from '@/services/posthog';

initLocalMode();
initPostHog();

function boot(): void {
  initNavbar();
  initFooterYear();
  initTocHighlight();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}

/**
 * Marks the rail entry for whichever section is currently in view.
 *
 * The rootMargin pushes the trigger line below the fixed navbar and up from the
 * bottom of the viewport, so a section counts as "current" once its heading is
 * comfortably on screen rather than the instant its first pixel appears.
 */
function initTocHighlight(): void {
  const sections = document.querySelectorAll<HTMLElement>('.fc-doc__section');
  const links = document.querySelectorAll<HTMLAnchorElement>('.fc-toc__link');
  if (!sections.length || !links.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const id = entry.target.getAttribute('id');
        links.forEach((link) => {
          link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
        });
      });
    },
    { rootMargin: '-100px 0px -60% 0px', threshold: 0 },
  );

  sections.forEach((section) => observer.observe(section));
}
